import { useEffect, useState } from "react";
import { Box, Button, Text, Heading } from "grommet";
import { Download } from "grommet-icons";

const columns = Array.from(Array(32), (e, i) => "Factor_".concat(String(i + 1)));
columns.unshift("Time");
columns.unshift("Date");
columns.unshift("ID");
columns.push("Probability");

const makeCSV = (content: any[]) => {
  return [columns, ...content.map((item) => [item.ID, item.Date, item.Time, ...item.Encoding, item.Probability])]
    .map((e) => e.join(","))
    .join("\n");
};

const CreateDownload = (data: any[]): string => {
  const output = makeCSV(data);
  const blob = new Blob([output]);
  return URL.createObjectURL(blob);
};

export interface DownloadButtonProps {
  data: any[];
}

export const DownloadButton = ({ data }: DownloadButtonProps): React.ReactElement => {
  const [fileDownloadUrl, setFileDownloadUrl] = useState("");

  useEffect(() => {
    data.length > 0 && setFileDownloadUrl(CreateDownload(data));
  }, [data]);

  return (
    <Box gap="medium">
      <Heading level={4} margin={{ top: "small", bottom: "none" }} textAlign="center">
        Download a csv containing the ECG factors and predictions
      </Heading>
      <Button
        icon={<Download />}
        label={<Text size="0.75em">DOWNLOAD</Text>}
        href={fileDownloadUrl}
        download={"FactorECG_encoding.csv"}
        primary
        size="large"
        disabled={fileDownloadUrl === "" ? true : false}
      />
    </Box>
  );
};
